import GoalActivityLogDetails from "./GoalActivityLogDetails";
import HolidayActivityLogDetails from "./HolidayActivityLogDetails";

/** Single activity row: same layout on Goal detail, My Activity, and Team Activity. */
export default function ActivityLogListItem({ entry }) {
  const meta = entry.metadata || {};
  const affectedName = entry.targetUserName || meta.goalOwnerName;
  const showAffected =
    affectedName &&
    entry.targetUserId != null &&
    String(entry.targetUserId) !== String(entry.userId);

  return (
    <li className="border-l-2 border-primary/30 pl-3 py-2">
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
        <span className="font-medium text-sm">{entry.actorName || "User"}</span>
        {showAffected && (
          <span className="text-xs text-gray-500">
            <span className="text-gray-400">→</span>{" "}
            <span className="font-medium text-gray-700">{affectedName}</span>
            <span className="text-gray-400 font-normal"> (affected user)</span>
          </span>
        )}
        <span className="text-xs text-gray-400">
          {entry.createdAt ? new Date(entry.createdAt).toLocaleString() : ""}
        </span>
      </div>
      <p className="text-gray-700 text-sm mt-0.5">{entry.description || entry.action}</p>
      <GoalActivityLogDetails entry={entry} />
      <HolidayActivityLogDetails entry={entry} />
    </li>
  );
}
